require("!!/var/app/node_modules/script-loader/addScript.js")(require("!!/var/app/node_modules/raw-loader/index.js!/var/app/public/js/anime.min.js"))


// WEBPACK FOOTER //
// ./public/js/anime.min.js